import { TreeTab } from "../Tabs/TreeTab.js"
import { DecorTab } from "../Tabs/DecorTab.js"
import { LightTab } from "../Tabs/LightTab.js"
import { OrnamentTab } from "../Tabs/OrnamentTab.js"
import { TreeTopTab } from "../Tabs/TreeTopTab.js"
import { GiftTab } from "../Tabs/GiftTab.js"
import { CreateDrawnBackLog } from "./BackSystems.js"
import { GroupTraySlide, ToggleTrayItems, TraySlide, TraySlideOut } from "./TweensFile.js"
/**
 * Handles clicks on tab buttons
 * the nature of .on passes the button clicked on
 * see Phaser 3 gameobject.pointerdown
 * (pointerdown sets scope to the object pointerdowned over)
 */

export function TabSwitcher()
{
    const TabName = this.getAt(0).frame.name.slice(4);
    const Scene = this.scene;
    const DepthList = Scene.DepthList;
    const ButtonPushed = this;

    if(Scene.Tray.x > 200)
    {
        WaitForTween();
    }
    else
    {
        _mainBody();
        GroupTraySlide(Scene.TrayGroup,"Out");
        let ToggleTimer = GroupTraySlide(Scene.TrayGroup,"Out");
        ToggleTimer.once('complete', function()
        {
            ToggleTrayItems(Scene.TrayGroup,true,Scene);
        });
    }

    async function WaitForTween()
    {
        //await TraySlide(Scene,Scene.Tray);
        ToggleTrayItems(Scene.TrayGroup,false,Scene);
        await GroupTraySlide(Scene.TrayGroup,"In")
        _mainBody();
        let ToggleTimer = GroupTraySlide(Scene.TrayGroup,"Out");
        ToggleTimer.once('complete', function()
        {
            ToggleTrayItems(Scene.TrayGroup,true,Scene);
        });
    }
    
    function _mainBody()
    {
        //console.log("Main Body");
        if (Scene.CurrentTabName != TabName)
        {
            ////console.log(Scene.input.removeAllListeners());

            //Scene.input.removeAllListeners();
            if(Scene.CleanUpHelp)
            {
                Scene.CleanUpHelp.destroy();
                Scene.CleanUpHelp = "";
            }
            Scene.HitBoxTree.removeAllListeners();
            if(Scene.CurrentTabName === 'Lts' || Scene.CurrentTabName === 'Grlnd')
            {
                //Scene.input.removeListener('pointerdown');
                //Scene.input.removeListener('pointermove');
            }

            //console.log(Scene.input);
            Scene.HitBoxTree.setDepth(DepthList.TreeDetail);

            Scene.TrayGroup.clear(true,true);
            Scene.CurrentTabName = TabName;
            Scene.CurrentTab.destroy();
            Scene.DrawState = false;

            switch (TabName)
            {
                case 'Trees':
                    TreeTab(Scene,Scene.Tray);
                    Scene.CurrentTab = Scene.addImage(132, ButtonPushed.y, ButtonPushed.getAt(0).frame.name +"_Bmp");
                    break;
                case 'Grlnd':
                    //Scene.HitBoxTree.removeAllListeners();
                    _resetDrawArray(Scene);
                    DecorTab(Scene,Scene.Tray);
                    DecorDrag(Scene);
                    Scene.CurrentTab = Scene.addImage(132, ButtonPushed.y, ButtonPushed.getAt(0).frame.name +"_Bmp");
                    break;
                case 'Lts':
                    Scene.HitBoxTree.removeAllListeners();
                    _resetDrawArray(Scene);
                    LightTab(Scene,Scene.Tray);
                    LightDrag(Scene);
                    Scene.DrawState = true;
                    Scene.CurrentTab = Scene.addImage(132, ButtonPushed.y, ButtonPushed.getAt(0).frame.name +"_Bmp");
                    break;
                case 'Orn':
                    OrnamentTab(Scene,Scene.Tray);
                    Scene.CurrentTab = Scene.addImage(132, ButtonPushed.y, ButtonPushed.getAt(0).frame.name +"_Bmp");
                    break;
                case 'TreTpr':
                    TreeTopTab(Scene,Scene.Tray);
                    Scene.CurrentTab = Scene.addImage(132, ButtonPushed.y, ButtonPushed.getAt(0).frame.name +"_Bmp");
                    _setGroupDepth(Scene);
                    break;
                case 'Gfts':
                    GiftTab(Scene,Scene.Tray);
                    Scene.CurrentTab = Scene.addImage(132, ButtonPushed.y, ButtonPushed.getAt(0).frame.name +"_Bmp");
                    _setGroupDepth(Scene);
                    break;
                default:
                    //console.log("error. Not A tab");
                    break;
            }
            Scene.CurrentTab.setDepth(DepthList.Buttons);
        }
    }
}

/**This function sets up the hitboxtree for pointerdown and pointermove
 * with Decor drawing. It is set up to be called every time the
 * Decor tab is clicked on because it is a more efficent way
 * to set the events instead of setting on creation, because
 * the tree can be created and destroyed dozens of times in a row
 * 
 * Works by using an array of objects to pull frame name and tint from the set object 
 * 
 * @param {*} Scene 
 */
function DecorDrag(Scene)
{
    let prev = {};
    let x;
    let y;
    const DepthList = Scene.DepthList;
    Scene.HitBoxTree.setDepth(DepthList.HitBoxTree);
    let DrawLogArray = [];

    Scene.HitBoxTree.on('pointerdown', (pointer) => {
        if(pointer.x > (Scene.Tray.x + (Scene.Tray.width *  .5)) && Scene.DrawArray.Name != "Temp" && Scene.DrawState === true)
        {
            //Scene.AudioChan.Chan1.play('lights_garland');
            if(!Scene.AudioChan.Chan1.isPlaying)Scene.AudioChan.Chan1.play('lights_garland-update');
            //Scene.sound.playAudioSprite('gameAudio','lights_garland-update');
            DrawLogArray = [];
            prev.x = pointer.x;
            prev.y = pointer.y;

            //points.push(new Phaser.Math.Vector2(pointer.x, pointer.y));
            let TempPlacedObject = Scene.addImage(pointer.x,pointer.y, Scene.DrawArray[0].Name).setAngle(setRandomAngle());
            TempPlacedObject.setTint(Scene.DrawArray[0].tint);
            TempPlacedObject.setScale(Scene.DrawArray[0].scale);
            TempPlacedObject.setDepth(DepthList.TreeItems);
            Scene.DrawCounter = 1;
            DrawLogArray.push(TempPlacedObject);
        }
    });

    Scene.HitBoxTree.on('pointermove', (pointer) => {

        if (pointer.isDown)
        {
            if(pointer.x > (Scene.Tray.x + (Scene.Tray.width *  .5)) && Scene.DrawArray.Name != "Temp" && Scene.DrawState === true)
            {
                x = pointer.x;
                y = pointer.y;

                if (Phaser.Math.Distance.Between(x, y, prev.x, prev.y) > Scene.DrawDistance)
                {
                    prev.x = x;
                    prev.y = y;

                    //Scene.AudioChan.Chan1.play('lights_garland');
                    //Scene.sound.playAudioSprite('gameAudio','lights_garland-update');
                    if(!Scene.AudioChan.Chan1.isPlaying)Scene.AudioChan.Chan1.play('lights_garland-update');

                    //points.push(new Phaser.Math.Vector2(pointer.x, pointer.y));
                    let TempPlacedObject = Scene.addImage(pointer.x,pointer.y, Scene.DrawArray[Scene.DrawCounter].Name).setAngle(setRandomAngle());
                    DrawLogArray.push(TempPlacedObject);
                    if(Scene.DrawArray[Scene.DrawCounter].tint)
                    {
                        if(!Scene.DrawArray[Scene.DrawCounter].hex)
                        {
                            TempPlacedObject.setTint(Scene.DrawArray[0].tint);
                        }
                        else
                        {
                            TempPlacedObject.setTint(Scene.DrawArray[Scene.DrawCounter].tint)
                        }
                    }
                    
                    TempPlacedObject.setScale(Scene.DrawArray[Scene.DrawCounter].scale);
                    TempPlacedObject.setDepth(DepthList.TreeItems);

                    if(TempPlacedObject.frame.name === "Pprmnt_BG")
                    {
                        DrawLogArray.push(Scene.addImage(pointer.x,pointer.y, "Pprmnt_Shdw").setDepth(DepthList.TreeItems));
                        DrawLogArray.push(Scene.addImage(pointer.x,pointer.y, "Pprmnt_Strps").setTint(Scene.DrawArray[0].tint).setDepth(DepthList.TreeItems));
                    }

                    if(Scene.DrawCounter < (Scene.DrawArray.length-1))
                    {
                        Scene.DrawCounter++;
                    }
                    else
                    {
                        Scene.DrawCounter = 0;
                    }
                }
            }
        }

    });

    Scene.input.on('pointerup',()=>
    {
        if (Scene.DrawState === true && DrawLogArray.length > 0)
        {
            DrawLogArray = _createBackLogCheck(DrawLogArray);
        }
    });
}

function LightDrag(Scene)
{
    var prev = {};
    var x;
    var y;
    const DepthList = Scene.DepthList;
    var RandAngle;
    Scene.HitBoxTree.setDepth(DepthList.HitBoxTree);
    let DrawLogArray = [];
    let Cont;

    Scene.HitBoxTree.on('pointerdown', (pointer) => {
        if(pointer.x > (Scene.Tray.x + (Scene.Tray.width *  .5)) && Scene.DrawArray.Name != "Temp")
        {
            DrawLogArray = [];
            prev.x = pointer.x;
            prev.y = pointer.y;

            if(!Scene.AudioChan.Chan1.isPlaying)Scene.AudioChan.Chan1.play('lights_garland-update');
            //Scene.sound.playAudioSprite('gameAudio','lights_garland-update');

            RandAngle = setRandomAngle();
            let Cont = Scene.add.container(pointer.x,pointer.y); 
            let TempLight = Scene.addImage(0,0, "Lt_Glow", Cont).setAngle(RandAngle);
            let TempPlacedObject = Scene.addImage(0,0, Scene.DrawArray[0].Name, Cont).setAngle(RandAngle);

            _setContInteractive(Cont,TempPlacedObject)
            //Scene.input.setDraggable(Cont);
            
            TempLight.setTint(_getGlowColor(TempPlacedObject.frame.name));

            Scene.LightGroup.add(TempLight);

            DrawLogArray.push(TempPlacedObject);
            DrawLogArray.push(TempLight);
            DrawLogArray.push(Cont);

            Scene.DrawCounter = 1;

            Cont.setData({AssetType:"Lts"});


            // Cont.on('drag',function(DragPointer,Dx,Dy){
            //     if(Scene.LightDragOffset != "Empty")
            //     {
            //         //console.log(Scene.LightDragOffset);
            //         // let OffsetX = this.x - DragPointer.x;
            //         // let OffsetY = this.y - DragPointer.y;
            //         //console.log(this.x,this.y,Dx,Dy);
            //         // this.x = Dx + OffsetX;
            //         // this.y = Dy + OffsetY;
            //         this.x = DragPointer.x + Scene.LightDragOffset.x;
            //         this.y = DragPointer.y + Scene.LightDragOffset.y;
            //     }
            //});
        }
    });

    Scene.HitBoxTree.on('pointermove', (pointer) => {

        if (pointer.isDown)
        {
            if(pointer.x > (Scene.Tray.x + (Scene.Tray.width *  .5)) && Scene.DrawArray.Name != "Temp")
            {
                x = pointer.x;
                y = pointer.y;

                if (Phaser.Math.Distance.Between(x, y, prev.x, prev.y) > Scene.DrawDistance)
                {
                    prev.x = x;
                    prev.y = y;

                    if(!Scene.AudioChan.Chan1.isPlaying)Scene.AudioChan.Chan1.play('lights_garland-update');
                    //Scene.sound.playAudioSprite('gameAudio','lights_garland-update');

                    //points.push(new Phaser.Math.Vector2(pointer.x, pointer.y));
                    //let ContPoint = Cont.pointToContainer(pointer);
                    let Cont = Scene.add.container(pointer.x,pointer.y);
                    ////console.log(ContPoint);
                    let TempLight = Scene.addImage(0,0, "Lt_Glow",Cont);
                    let TempPlacedObject = Scene.addImage(0,0, Scene.DrawArray[Scene.DrawCounter].Name,Cont).setAngle(setRandomAngle());
                    
                    TempPlacedObject.setData({AssetType:"Lts",Container:Cont});
                    
                    TempLight.setTint(_getGlowColor(TempPlacedObject.frame.name));

                    Scene.LightGroup.add(TempLight);
                    DrawLogArray.push(TempPlacedObject);
                    DrawLogArray.push(TempLight);
                    DrawLogArray.push(Cont);

                    if(Scene.DrawCounter < (Scene.DrawArray.length-1))
                    {
                        Scene.DrawCounter++;
                    }
                    else
                    {
                        Scene.DrawCounter = 0;
                    }
                    _setContInteractive(Cont,TempPlacedObject);
                    //Cont.setInteractive();

                    // TempPlacedObject.setInteractive();
                    // TempPlacedObject.on("pointerdown",function(pointer){

                    //     let PointerVector = new Phaser.Math.Vector2(pointer);

                    //     Scene.input.setDragState(Scene.input.activePointer,0);

                    //     let ContRef = this.getData('Container');

                    //     let GameObjVector = new Phaser.Math.Vector2(ContRef);
                    //     //console.log(PointerVector,GameObjVector);

                    //     Scene.LightDragOffset = GameObjVector.subtract(PointerVector);

                    //     Scene.input._drag[1][0] = ContRef;
                    //     Scene.input._drag[0][0] = ContRef;
                    //     Scene.input.setDragState(pointer,4);
                    // });
                }
            }
        }

    });

    Scene.input.on('pointerup',()=>
    {
        //console.log(DrawLogArray.length)
        if (Scene.DrawState === true && DrawLogArray.length > 0)
        {
            DrawLogArray = _createBackLogCheck(DrawLogArray);
        }
    });
}
function _setContInteractive(Cont,Glow)
{
    Cont.setDepth(Glow.scene.DepthList.TreeItems);
    Cont.setSize(Glow.width,Glow.height);
    Cont.setInteractive();

    Cont.setData({AssetType:"Lts"});
    Glow.scene.input.setDraggable(Cont);
}

/**Function used to rotate the lights placed
 * 
 */
function setRandomAngle()
{
    let ReturnedValue = Math.floor(Math.random()*31);
    Math.floor(Math.random()*2) ? ReturnedValue = ReturnedValue*-1 : ReturnedValue;
    //console.log(ReturnedValue);

    return ReturnedValue;
}

function _resetDrawArray(Scene)
{
    Scene.DrawArray = {Name: "Temp"};
}

function _getGlowColor(LightName)
{
    let ReturnVal;
    switch(LightName)
    {
        case "Lt_Aqua":
            ReturnVal = 0x00FFFF;
            break;
        case "Lt_Grn":
            ReturnVal = 0x83FF00;
            break;
        case "Lt_Prpl":
            ReturnVal = 0xC51DFF;
            break;
        case "Lt_Ylw":
            ReturnVal = 0xFFFF00;
            break;
        case "Lt_Blue":
            ReturnVal = 0x00A4FF;
            break;
        case "Lt_Orng":
            ReturnVal = 0xFFAB27;
            break;
        case "Lt_Rd":
            ReturnVal = 0xF70D0D;
            break;
        case "Lt_Pnk":
            ReturnVal = 0xFF00CF;
            break;
        default:
            break;
    }
    //console.log(ReturnVal);
    return ReturnVal;
}

/**Used to set the depth of tray items that are not multidepth - if this is not called
 * tray depth is being handled by the Tab folder.
 * 
 * @param {*} Scene 
 */
function _setGroupDepth(Scene)
{
    Scene.TrayGroup.getChildren().forEach(element => {
        element.setDepth(Scene.DepthList.OrnBack);
    });
    if(Scene.CurrentTabName === "Gfts")
    {
        Scene.GiftGroup.getChildren().forEach(element => {
            element.setDepth(Scene.DepthList.OrnMiddle);
        });
    }
}

function _createBackLogCheck(DrawLogArray)
{
    CreateDrawnBackLog(DrawLogArray,"Created");
    DrawLogArray = [];

    return DrawLogArray;
}